export default __webpack_public_path__ + "static/media/banner-image-6.a62c7dcf.png";